import React from 'react'
import { number, string } from 'prop-types'
import { Avatar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Stats from './Components/Stats'

function UserCard({
  username = null,
  userPicture = null,
  reviewCount = 0,
  userRating = 0,
}) {
  return (
    <div className="cgt-user-card-new">
      <Avatar size="40" img={userPicture} username={username} />
      <div className="cgt-user-card-new__user-info">
        <span className="cgt-legacy-text-caption cgt-legacy-text-caption--inherit-color">
          {username}
        </span>
        <Stats
          userRating={userRating}
          reviewCount={reviewCount}
        />
      </div>
    </div>
  )
}

UserCard.propTypes = {
  username: string,
  userPicture: string,
  reviewCount: number,
  userRating: number,
}

export default UserCard
